
import { loadModules } from 'esri-loader';
import parse, { DxfParser } from 'dxf-parser';

//TO TEST
//https://geojson.io

class MitGisJSONService {
  constructor() {
  }

  initErsi(){
      return new Promise ((resolve, reject) => {
          loadModules(['esri/geometry/Point', 'esri/geometry/projection'])
              .then(([Point, Projection]) => {
                    Projection.load().then(() => {
                        this.Point = Point;
                        this.Projection = Projection;
                        return resolve(true);
                    });
              })
              .catch( (error) => {
                  console.log('FAILED to load esri modules', error);
              });


      });
  }

  convertPointsToLatLong(points){
      let pointsLatLong = [];

      let inSpatialReference = {
          wkid:102686 //MIT spatial reference
      };
      let outSpatialReference = {
        /*
        4326 is the most common spatial reference for storing a referencing data across the
        entire world. It serves as the default for both the PostGIS spatial database and the
        GeoJSON standard. It is also used by default in most web mapping libraries
        */
        wkid: 4326
      };

      let ersiPoints = [];
      for(let i = 0; i < points.length; i++){
          ersiPoints.push(new this.Point({x: points[i][0],y: points[i][1],z: 0, spatialReference: {wkid: inSpatialReference.wkid}}));
      }

      let projectedPoints = this.Projection.project(ersiPoints, outSpatialReference);

      projectedPoints.forEach((p) => {
            //GEOJSON [longitude, lattitude]
            //NOTE: This is opposite of google maps expected order
            pointsLatLong.push([p.x, p.y]);
      });

      return pointsLatLong;
  }

  extractSpaceFeature(spaceData){

      let feature = {
          "type": "Feature",
          "geometry": {
              "type": spaceData.geometryType,
              "coordinates": spaceData.geometryCoordinates,
          },
          "properties":{
              "mitId":spaceData.mitId,
              "mitIdShort":spaceData.mitIdShort,
              "name":spaceData.name,
              "description":spaceData.description,
              "level":spaceData.level,
              "floorId": spaceData.floorId,
              "sqfoot":spaceData.sqfoot,
              "org": spaceData.org,
              "rotation":0,
              "useType": spaceData.useType,
              "useCategory": spaceData.useCategory,
              "spaceType":spaceData.spaceType,
              "coordinates102686":spaceData.coordinates102686
          }
      }

      return feature;

  }
  createSpace(mitId, mitIdShort, level, sqfoot, org, useType,  useCategory, spaceType, geometryList, geometryType){
      let coordinates = null;

      if(geometryList){
          coordinates = [];

          for(let r = 0; r < geometryList.length; r++){
              coordinates.push(this.convertPointsToLatLong(geometryList[r]));
          }

      }

      return {
          mitId:mitId,
          mitIdShort:mitIdShort,
          name:'',
          description:'',
          level:level,
          sqfoot:sqfoot,
          org: org,
          useType: useType,
          useCategory: useCategory,
          spaceType:spaceType,
          rotation:0,
          geometryCoordinates:coordinates,
          geometryType: geometryType, //for the moment we only support this type,
          children:[]
      }
  }
  extractMapData(map){
      return new Promise ((resolve, reject) => {
          let data = map.features;
          let result = {
              geoJSON:{
                  "type": "FeatureCollection",
                "features": []
              },
              geoJSONFloorsDict:{},
              spaceFloorsDict:{},
              spacesTree:[],
              info:{
                  spaceTypes:[],
                  levels:[],
                  orgs:[],
                  spaceUses:[]
              },
              spacesList:[],
              spacesDict:{}
          };
          this.initErsi().then( () => {
              let building = null;

              //Dictionary for finding distinct info about this map
              let levelsDict = {};
              let spaceTypesDict = {};
              let orgsDict = {};
              let spaceUsesDict = {};

              //get the building id.
              let buildingId = data[0].attributes.SPACE_NAME.substring(0, data[0].attributes.SPACE_NAME.indexOf('-'));
              buildingId = buildingId.replace(/\D/g,''); //remove any letters stuck in there, facilities added the bottom floor as 32P for some reason in one of the updates.
              //store off the building
              result.spacesTree.push(
                  this.createSpace(
                      buildingId,
                      buildingId,
                      null,
                      null,
                      null,
                      null,
                      null,
                      'building',
                      null,
                      null
                  ));
              building = result.spacesTree[0];

              let feature = null;
              let floor = null;
              let currentSpace = null;

              let attrRoomUse,attrLevel,attrOrg,attrMajorUse,attrName,attrArea,attrBuildingFloor;
              for(let j = 0; j < data.length; j++){
                  //attributes
                  attrRoomUse = data[j].attributes.Room_Use || data[j].attributes.ROOM_USE;
                  attrLevel = parseInt(data[j].attributes.LEVEL_ID);
                  attrOrg = data[j].attributes.ORG;
                  attrMajorUse = data[j].attributes.MAJOR_USE;
                  attrName = data[j].attributes.SPACE_NAME;
                  attrArea = data[j].attributes.AREA_SQFT || data[j].attributes.AREA;
                  attrArea = parseInt(attrArea);
                  attrBuildingFloor = data[j].attributes.BLDG_FLOOR;

                  spaceTypesDict[attrRoomUse] = attrRoomUse;
                  levelsDict[attrLevel] = attrLevel;
                  orgsDict[attrOrg] = attrOrg;
                  spaceUsesDict[attrMajorUse] = attrMajorUse;

                  currentSpace = this.createSpace(
                      attrName,
                      attrName.substring(attrName.indexOf('-')+1),
                      attrLevel,
                      attrArea,
                      attrOrg,
                      attrRoomUse,
                      attrMajorUse,
                      'space',
                      data[j].geometry.rings,
                      'Polygon'
                  );
                    let feature = this.extractSpaceFeature(currentSpace)

                    result.geoJSON.features.push(feature);

                    //See if we need to create a floor
                    if(result.spaceFloorsDict.hasOwnProperty(currentSpace.level) === false){
                        //create a floor
                        floor = this.createSpace(
                            attrBuildingFloor,
                            currentSpace.level,
                            currentSpace.level,
                            null,
                            null,
                            null,
                            null,
                            'floor',
                            null,
                            'LineString'
                        );
                        let featureFloor = this.extractSpaceFeature(floor)

                        //add it to a lookup for convinience
                        result.spaceFloorsDict[currentSpace.level] = floor;
                        //add the floor to the building
                        building.children.push(floor);

                        result.spacesDict[currentSpace.level] = {};
                    }

                    floor = result.spaceFloorsDict[currentSpace.level];



                      floor.children.push(currentSpace);
                      result.spacesList.push(currentSpace);
                      result.spacesDict[currentSpace.level][currentSpace.mitId] = currentSpace;
                  //}

              }

              //Save off the searchable values
              for (let l in levelsDict) {
                  result.info.levels.push(levelsDict[l]);
              }
              for (let t in spaceTypesDict) {
                  result.info.spaceTypes.push(spaceTypesDict[t]);
              }
              for (let t in orgsDict) {
                  result.info.orgs.push(orgsDict[t]);
              }
              for (let t in spaceUsesDict) {
                  result.info.spaceUses.push(spaceUsesDict[t]);
              }
              // result.info.levels.sort();
              result.info.levels.sort(function(a, b) {
                  return a - b;
              });

              return resolve(result);
          });
      });
  }


}

export default MitGisJSONService;
